import { SelectionChangedEvent } from "ag-grid-community";
import { INITIAL_EMP_POOL_STORAGE_GEN_COL_DEF_OICT, INITIAL_EMP_POOL_STORAGE_GEN_COL_DEF_SAPT, transferRowData } from "presentation/constant/EmptyPoolStorageGeneration/EmptyPoolStorageGenColumnDefinition";
import { useEmptyPoolStorageGenVM } from "presentation/hook/EmptyPoolStorageGeneration/useEmptyPoolStorageGenVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useEmptyPoolStorageGenTracked } from "presentation/store/EmptyPoolStorageGeneration/EmptyPoolStorageGenProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";

const EmptyPoolStorageGenTablePanel: React.FC = () => {
    const [emptyPoolStorageGenState] = useEmptyPoolStorageGenTracked();
    const emptyPoolStorageGenVM = useEmptyPoolStorageGenVM();
    let gridRef: any = useRef();
    const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    const [anaInfoState] = useANAInfoTracked();
    const { operatingUnit } = anaInfoState;
    const [showOverlay, setShowOverlay] = useState<boolean>(false);

    useEffect(() => {
        setShowOverlay(emptyPoolStorageGenState.isSearchLoading || (!emptyPoolStorageGenState.isSearchLoading &&
            emptyPoolStorageGenState.emptyPoolDatas && emptyPoolStorageGenState.emptyPoolDatas.length) ? false : true);

        if (gridRef.current?.gridRef.current && !emptyPoolStorageGenState.isSearchLoading &&
            gridRef.current?.gridRef.current?.api?.getSelectedNodes()?.length > 0) {
            gridRef.current?.gridRef.current?.api?.getSelectedNodes()?.forEach((node: any) => {
                node.setSelected(false);
            });
        }
    }, [emptyPoolStorageGenState.isSearchLoading, emptyPoolStorageGenState.emptyPoolDatas]);

    useEffect(() => {
        if (!emptyPoolStorageGenState.selectedEmptyPoolDatas ||
            emptyPoolStorageGenState.selectedEmptyPoolDatas.length <= 0) {
            //gridRef.current?.gridRef.current.api?.setColumnDefs(INITIAL_EMP_POOL_STORAGE_GEN_COL_DEF?.slice());

            if (!onTableSelectionClicked) {
                gridRef.current?.gridRef.current.api?.deselectAll();
            }
        }
    })

    useEffect(() => {
        if (onTableSelectionClicked) return;

        gridRef.current?.gridRef.current.api?.deselectAll();

    }, [onTableSelectionClicked])

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        setOnTableSelectionClicked(true);
        const selectedRows = e.api.getSelectedRows();
        emptyPoolStorageGenVM.updateSelectedEmpPoolDatas(selectedRows);
    }, [emptyPoolStorageGenVM])

    const memoEmptyPoolStorageDataTable = useMemo(() => {
        return (
            <>
                <NbisTable
                    id='empty-pool-storage-data-table'
                    isNewColumnSetting={true}
                    columns={((operatingUnit === 'SAPT' || operatingUnit === 'KICT') ? INITIAL_EMP_POOL_STORAGE_GEN_COL_DEF_SAPT
                        : INITIAL_EMP_POOL_STORAGE_GEN_COL_DEF_OICT)?.slice()}
                    // headerLabel={EmptyPoolStorageGenConstant.Charge.DATA_LIST}
                    data={transferRowData(emptyPoolStorageGenState.emptyPoolDatas ?? [])}
                    showPaginator={false}
                    editable={false}
                    showHeaderIcons={true}
                    showAddIcon={false}
                    showDeleteButton={false}
                    showReloadIcon={false}
                    isScrollHighlighted={true}
                    selectionMode={false}
                    handleSelectionChanged={handleSelectionChange}
                    ref={gridRef}
                    rowSelection={"multiple"}
                    isRowHighligted={true}
                    gridHeight="customHeight"
                    customHeight="calc(100vh - 125px)"
                    showDefaultOverlayNoRowsTemplate={showOverlay}
                />
            </>
        );
    }, [emptyPoolStorageGenState.emptyPoolDatas, handleSelectionChange, operatingUnit, showOverlay])

    return <><TableWrapper>{memoEmptyPoolStorageDataTable}</TableWrapper></>;
}

export default memo(EmptyPoolStorageGenTablePanel);
